$(document).ready(function() {
    $('.price.price--show-badge').each(function() {
        var $badgeContainer = $(this);
        var $priceSaleBadge = $badgeContainer.find('.price__badge-sale');
        var $priceSoldOutBadge = $badgeContainer.find('.price__badge-sold-out');
        // Check if .price__badge-sale or .price__badge-sold-out is display: none
        if ($priceSaleBadge.css('display') === 'none' && $priceSoldOutBadge.css('display') === 'none') {
            $badgeContainer.find('.bestsellerBedge').addClass('newBedgeTag-custom');
          console.log("abcd")
        } else {
            $badgeContainer.find('.bestsellerBedge').removeClass('newBedgeTag-custom');
        }
    });
});
// More Less JS
// document.addEventListener("DOMContentLoaded", function () {
//     var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
//     if (screenWidth <= 767) {
//       var contentList = document.querySelectorAll(".collection-hero__description");

//       contentList.forEach(function (content) {
//         var btnText = document.createElement("span");
//         btnText.classList.add("toggleButton");
//         btnText.innerText = "Read More";

//         if (content.textContent.length > 100) {
//           var first300 = content.textContent.substring(0, 200);
//           var remaining = content.textContent.substring(200);

//           content.innerHTML = first300 + '<span class="dots">...</span><span class="moreText" style="display:none;">' + remaining + "</span> ";
//           content.appendChild(btnText);
//         }

//         btnText.addEventListener("click", function () {
//           toggleText(this);
//         });
//       });
//     }
//   });

//   function toggleText(button) {
//     var dots = button.previousElementSibling.previousElementSibling;
//     var moreText = button.previousElementSibling;

//     // Find all other "More" buttons and close them
//     var allButtons = document.querySelectorAll(".toggleButton");
//     allButtons.forEach(function (btn) {
//       var btnDots = btn.previousElementSibling.previousElementSibling;
//       var btnMoreText = btn.previousElementSibling;

//       if (btn !== button && btnDots.style.display === "none") {
//         btnDots.style.display = "inline";
//         btnMoreText.style.display = "none";
//         btn.innerHTML = "Read More";
//       }
//     });

//     if (dots.style.display === "none") {
//       dots.style.display = "inline";
//       moreText.style.display = "none";
//       button.innerHTML = "Read More";
//     } else {
//       dots.style.display = "none";
//       moreText.style.display = "inline";
//       button.innerHTML = "Read Less";
//     }
//   }

